module.exports = __webpack_public_path__ + "img/38793-039.976273af.jpg";